import { formatArea } from "@nova/format"
import { config } from "@nova/configuration/browser"
import { AreaUnit, HotspotWithLabel } from "@nova/constants"
import { dateFromNumber } from "@nova/serializer/src/client/util"
import { selectActiveWorkspace } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectInfraredImageById } from "features/entity-caching/images/hotspots/selectors"
import { selectActivatedFire } from "features/map/control/selectors"
import store from "integrations/redux/store"

export const getPropertiesForHotspots = (hotspots: HotspotWithLabel[]) => {
    const state = store.getState()
    const organizationSettingArea = config.get("organizationSettingArea") as AreaUnit
    const useMeters =
        organizationSettingArea === AreaUnit.Hectares ||
        organizationSettingArea === AreaUnit.SquareKilometers
    const workspace = selectActiveWorkspace()(state)
    const project = selectActivatedFire(state)!
    const areaKey = `area (${useMeters ? "sq m" : "sq ft"})`
    return hotspots.map((hotspot) => {
        const createdAt = dateFromNumber(selectInfraredImageById(hotspot.imageId)(state)?.takenAt)
        return {
            id: hotspot.label,
            label: hotspot.label,
            year: createdAt.getFullYear(),
            date: createdAt.toDateString(),
            time: createdAt.getHours() + "" + createdAt.getMinutes(),
            latitude: hotspot.latitude,
            longitude: hotspot.longitude,
            [areaKey]: useMeters
                ? hotspot.area
                : formatArea({ value: hotspot.area || 0, unit: AreaUnit.SquareFeet }),
            sensitivity: hotspot.confidence,
            FIRENUMBER: project.name,
            SOURCE: "",
            AGENCY: workspace?.name || "",
            REMARK: "",
            VISIT: "",
            VISIT_CREW: "",
            VISIT_DATE: "",
            VISIT_TIME: "",
        }
    })
}
